module.exports = __webpack_public_path__ + "static/media/SWSCRC-1B.66dd9fae.mp3";